import { Box, Card, CardContent, Tabs, Tab, Typography, Tooltip, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SimpleShowLayout, TextField, EmailField, DateField, FunctionField, TopToolbar, Button, useRedirect, useNotify, Link, Labeled, useGetOne } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { useLocation, useParams } from "react-router-dom";
import { TrashButton } from "../components";
import { cleanTimeChoices, formatPhoneNumberStrict, formatPostalCode, getNameAndCompanyName, getNameAndCompanyNamewithAddress, invoiceChoices } from "../common";
import ListIcon from '@mui/icons-material/List';
import AddIcon from '@mui/icons-material/Add';

const CustomerShow = () => {
  const { id } = useParams();
  const location = useLocation();
  const resource = location.pathname.split("/")[1];
  const [customer, setCustomer] = useState(null);
  const [files, setFiles] = useState(null);
  const [requesters, setRequesters] = useState([]);

  const redirect = useRedirect();
  const notify = useNotify();

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
      <TopToolbar>
        <Button
          label="顧客情報編集"
          onClick={() => redirect(`/${resource}/${id}`)}
          startIcon={<EditIcon />}
        />
      </TopToolbar>
    </Box>
  );

  const { data, isLoading } = useGetOne("customers", { id });
  useEffect(() => {
    if (!isLoading && data) {
      setCustomer(data);
    }
  }, [data, isLoading]);


  useEffect(() => {
    const fetchRequesters = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/requesters/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setRequesters(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchRequesters();
  }, []);

  useEffect(() => {
    if (customer) {
      const fetchFiles = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_DIR}/documents/contract/${customer.id}`, {
            method: "GET",
            headers: new Headers({ "Content-Type": "application/json" }),
            mode: "cors",
            credentials: "include",
          });
          const data = await response.json();
          if (data.files) {
            setFiles(data.files);
          }
        } catch (error) {
          console.error("ファイル一覧の取得に失敗しました:", error);
          notify("ファイル一覧の取得に失敗しました", { type: "error" });
        }
      };
      fetchFiles();
    }
  }, [customer]);

  const DownloadFile = async (filePath) => {
    window.open(`${process.env.REACT_APP_API_DIR}/documents/download?filePath=${filePath}`)
  };

  const handleDelete = (filePath) => {
    const deleteFile = async (filePath) => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/documents`, {
          method: "DELETE",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({ filePath }),
        });
        const data = await response.json();
        if (data.isError) {
          notify(data.message || "エラーが発生しました", { type: "error" });
        }
        else {
          notify("削除されました", { type: "sccuess" });
          window.location.reload();
        }
      } catch (error) {
        notify("エラーが発生しました", { type: "error" });
      }
    };
    deleteFile(filePath);
  };

  const labelStyle = (text) => (
    <div style={{ backgroundColor: "#777", color: "#fff", padding: "2px 5px", textAlign: "center", fontSize: "12px" }}>
      {text}
    </div>
  );

  const historyButton = (listUrl, createUrl, editUrl, id) => (
    <>
      {/* 履歴一覧ボタン */}
      <Tooltip title="すべての履歴を見る" arrow >
        <IconButton
          component={Link}
          to={listUrl}
          size="small"
          color="primary"
          disabled={!id}
        >
          <ListIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {/* 追加ボタン */}
      <Tooltip title="履歴を追加" arrow>
        <IconButton
          component={Link}
          to={createUrl}
          size="small"
          color="success"
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      {/* 編集ボタン */}
      <Tooltip title="履歴を編集" arrow>
        <IconButton
          component={Link}
          to={editUrl} // 編集URLは用途に応じて変更
          size="small"
          color="warning"
          disabled={!id}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </>
  );

  return (
    <>
      {customer && (
        <>
          <CustomTopToolbar />
          <Card>
            <CardContent >
              <SimpleShowLayout record={customer} sx={{ p: 0 }}>
                <div style={{ display: "flex", width: "100%" }}>
                  <div style={{ width: "50%", margin: "0 5px" }}>
                    <div style={{ marginBottom: "15px" }}>
                      <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>基本情報</div>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("顧客タイプ")}
                          <FunctionField label={labelStyle("顧客タイプ")} style={{ paddingLeft: "5px" }}
                            render={(record) => {
                              const array = [];
                              if (record.isCleanCus) array.push("浄化槽清掃");
                              if (record.isInspectCus) array.push("浄化槽点検");
                              if (record.isConstructCus) array.push("浄化槽修理");
                              if (record.isGarbageCommitCus) array.push("ごみ収集許委託");
                              if (record.isGarbageAllowCus) array.push("ごみ収集許可");
                              if (record.isWasteCus) array.push("し尿");

                              return array.join("・")
                            }}
                          />
                        </div>

                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("物件名")}
                          <FunctionField label={labelStyle("名前")} style={{ paddingLeft: "5px" }}
                            render={(record) => {
                              return `${record.bukken ?? ""}`
                            }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("物件名")}
                          <FunctionField label={labelStyle("名前")} style={{ paddingLeft: "5px" }}
                            render={(record) => {
                              return `${record.bukken_k ?? ""}`
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("顧客名")}
                          <FunctionField label={labelStyle("名前")} style={{ paddingLeft: "5px" }}
                            render={(record) => {
                              return `${record.surname ?? ""}`
                            }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("顧客名(カナ)")}
                          <FunctionField label={labelStyle("名前")} style={{ paddingLeft: "5px" }}
                            render={(record) => {
                              return `${record.surname_k ?? ""}`
                            }}
                          />
                        </div>
                      </div>
                      {/* <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1 ,width:"100%",backgroundColor:"#eee" ,border: "1px solid #777" }}>
                          {labelStyle("会社名")}
                          <TextField source="companyName" label={labelStyle("会社名")} style={{ paddingLeft: "5px" }} />
                        </div>
                         <div style={{ display: "flex", marginBottom: "5px", flex: 1 ,width:"100%",backgroundColor:"#eee" ,border: "1px solid #777" }}>
                          {labelStyle("会社名(フリガナ)")}
                          <TextField source="companyName_k" label={labelStyle("会社名")} style={{ paddingLeft: "5px" }} />
                        </div>
                      </div> */}
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("電話番号１")}
                          <FunctionField
                            render={(record) => record.phone ?? ""}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("電話番号２")}
                          <FunctionField
                            render={(record) => record.telephone ?? ""}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("FAX")}
                          <FunctionField
                            render={(record) => record.fax ?? ""}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777", flex: 1 }}>
                          {labelStyle("メール")}
                          <EmailField source="mail" style={{ paddingLeft: "5px" }} />
                        </div>
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("住所")}
                        <FunctionField label={labelStyle("住所")} style={{ paddingLeft: "5px" }}
                          render={record => {
                            return `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`;
                          }}
                        />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("ゼンリン地図番号")}
                        <FunctionField label={labelStyle("ゼンリン地図番号")} style={{ paddingLeft: "5px" }}
                          render={(record) => {
                            return (record.mapNumber && record.mapNumber2 && record.mapNumber3) ? `p ${record.mapNumber} ${record.mapNumber2} ${record.mapNumber3}` : ""
                          }}
                        />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("備考")}
                        <TextField source="remarks" label={labelStyle("備考")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("登録日")}
                          <DateField source="createDate" label={labelStyle("登録日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("更新日")}
                          <DateField source="updateDate" label={labelStyle("更新日")} style={{ paddingLeft: "5px" }} />
                        </div>
                      </div>

                    </div>
                  </div>
                  <div style={{ width: "50%", margin: "0 5px" }}>
                    {(customer.isCleanCus || customer.isConstructCus || customer.isInspectCus) ? (
                      <>
                        <div style={{ marginBottom: "15px" }}>
                          <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>浄化槽情報</div>
                          <div style={{ display: "flex" }}>
                            <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                              {labelStyle("処理方式")}
                              <TextField source="processMethod" label={labelStyle("処理方式")} style={{ paddingLeft: "5px" }} />
                            </div>
                            <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                              {labelStyle("処理区分")}
                              <FunctionField
                                source="processCategory"
                                label={labelStyle("処理区分")}
                                render={(record) => {
                                  if (record.processCategory === 1) {
                                    return "単独";
                                  }
                                  else if (record.processCategory === 2) {
                                    return "合併";
                                  }
                                  else {
                                    return "";
                                  }
                                }}
                                style={{ paddingLeft: "5px" }}
                              />
                            </div>
                            <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                              {labelStyle("規模")}
                              <TextField source="scale" label={labelStyle("規模")} style={{ paddingLeft: "5px" }} />
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                              {labelStyle("浄化槽メーカー")}
                              <TextField source="tankMaker" label={labelStyle("浄化槽メーカー")} style={{ paddingLeft: "5px" }} />
                            </div>
                            <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                              {labelStyle("浄化槽型式")}
                              <TextField source="tankType" label={labelStyle("浄化槽型式")} style={{ paddingLeft: "5px" }} />
                            </div>

                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {(customer.isCleanCus) ? (
                      <>
                        <div style={{ marginBottom: "15px" }}>
                          <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>清掃情報</div>
                          <div style={{ display: "flex", marginBottom: "5px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("清掃単価(円)")}
                            <FunctionField source="exPumpingPay" label={labelStyle("単価(円)")} style={{ paddingLeft: "5px" }}
                              render={(record) => {
                                return record.exPumpingPay ? `${record.exPumpingPay.toLocaleString()}円` : ""
                              }}
                            />
                          </div>
                          <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("管理業者")}
                            <FunctionField
                              source="requesterId"
                              label={labelStyle("管理業者")}
                              render={(record) => {
                                const user = requesters.find(req => req.id === record.requesterId);
                                if (user) {
                                  return `${user.companyName}`;
                                }
                              }}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {(customer.isInspectCus) ? (
                      <>
                        <div style={{ marginBottom: "15px" }}>
                          <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>点検情報</div>
                          <div style={{ display: "flex" }}>
                            <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                              {labelStyle("点検月")}
                              <FunctionField source="checkMonth" label={labelStyle("点検月")} style={{ paddingLeft: "5px" }}
                                render={record => {
                                  return `${record.checkMonth ? record.checkMonth.replaceAll("、", "・") : ""}`;
                                }}
                              />
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                              {labelStyle("点検回数")}
                              <FunctionField label={labelStyle("点検回数")} style={{ paddingLeft: "5px" }}
                                render={(record) => record.checkMonth ? (record.checkMonth.split("、")).length : 0}
                              />
                            </div>
                            <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                              {labelStyle("請求月")}
                              <FunctionField source="invoiceMonth" label={labelStyle("請求月")} style={{ paddingLeft: "5px" }}
                                render={(record) => {
                                  return record.invoiceMonth ? `${record.invoiceMonth}月` : ""
                                }}
                              />
                            </div>
                            <div style={{ display: "flex", marginBottom: "5px", flex: 2, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                              {labelStyle("保守点検料(税抜き)")}
                              <FunctionField source="contractAmount" label={labelStyle("保守点検料(税抜き)")} style={{ paddingLeft: "5px" }}
                                render={(record) => {
                                  return record.contractAmount ? `${record.contractAmount.toLocaleString()}円` : ""
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {customer.isGarbageAllowCus ? (
                      <>
                        <div style={{ marginBottom: "15px" }}>
                          <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>ごみ収集許可情報</div>
                          <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("ごみ収集の曜日")}
                            <TextField source="garbageCollectWeek" label={labelStyle("ごみ収集の曜日")} style={{ paddingLeft: "5px" }} />
                          </div>
                        </div>
                      </>

                    ) : (
                      <></>
                    )}
                  </div>
                </div>

                {(customer.isInspectCus || customer.isGarbageAllowCus) ? (
                  <>
                    <div style={{ display: "flex", width: "100%" }}>
                      <div style={{ width: "50%", margin: "0 5px", marginBottom: "15px" }}>
                        <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>契約者情報</div>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("顧客名")}
                            <FunctionField
                              render={(record) => `${record.contract_surname ?? ""}　${record.contract_name ?? ""}`}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                          {/* <div style={{ display: "flex", marginBottom: "5px", flex: 1.5 ,width:"100%",backgroundColor:"#eee",border: "1px solid #777"}}>
                            {labelStyle("会社名")}
                            <TextField source="contract_companyName" style={{ paddingLeft: "5px" }} />
                          </div> */}
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("電話番号１")}
                            <FunctionField
                              render={(record) => record.contract_phone ?? ""}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                          <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("電話番号２")}
                            <FunctionField
                              render={(record) => record.contract_telephone ?? ""}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                          <div style={{ display: "flex", marginBottom: "5px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("FAX")}
                            <FunctionField
                              render={(record) => record.contract_fax ?? ""}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "flex", marginBottom: "5px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("住所")}
                            <FunctionField
                              render={record => {
                                return `${record.contract_postCode ? record.contract_postCode : ""} ${record.contract_address ?? ""}${record.contract_address2 ?? ""}${record.contract_address3 ?? ""}${record.contract_address4 ?? ""}${record.contract_address5 ?? ""}`;
                              }}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("契約日")}
                            <DateField source="contractDate" label={labelStyle("契約日")} style={{ paddingLeft: "5px" }} />
                          </div>
                          {/* <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 2 ,width:"100%",backgroundColor:"#eee",border: "1px solid #777"}}>
                            {labelStyle("契約金(税抜き)")}
                            <FunctionField source="contractAmount" label={labelStyle("契約金(税抜き)")} style={{ paddingLeft: "5px" }}
                              render={(record) => {
                                return record.contractAmount ? `${record.contractAmount.toLocaleString()}円` : ""
                              }}
                            />
                          </div> */}
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("備考")}
                          <TextField source="contract_remarks" label={labelStyle("備考")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ marginBottom: "5px" }}>
                          {labelStyle("契約書ファイル")}
                          <FunctionField
                            source="documentURL"
                            label={labelStyle("契約書ファイル")}
                            render={(record) => (
                              <div style={{ margin: "0", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                                {files && files.length > 0 ? (
                                  <div style={{ display: "flex" }}>
                                    {files.map((file, index) => (
                                      <div key={index} style={{ paddingLeft: "5px" }}>
                                        <Link
                                          onClick={() => DownloadFile(file.url)}
                                          style={{ fontSize: '12px', lineHeight: 1, padding: 0, margin: 0 }}
                                        >
                                          {file.name}
                                        </Link>
                                        <TrashButton
                                          onDelete={() => handleDelete(file.url)} />
                                      </div>
                                    ))}
                                  </div>
                                ) : null}
                              </div>
                            )}
                          />
                        </div>
                      </div>
                      <div style={{ width: "50%", margin: "0 5px", marginBottom: "15px" }}>
                        <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>オーナー情報</div>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("顧客名")}
                            <FunctionField
                              render={(record) => `${record.orner_surname ?? ""}　${record.orner_name ?? ""}`}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                          {/* <div style={{ display: "flex", marginBottom: "5px", flex: 1.5 ,width:"100%",backgroundColor:"#eee",border: "1px solid #777" }}>
                            {labelStyle("会社名")}
                            <TextField source="orner_companyName" style={{ paddingLeft: "5px" }} />
                          </div> */}
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("電話番号１")}
                            <FunctionField
                              render={(record) => record.orner_phone ?? ""}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                          <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("電話番号２")}
                            <FunctionField
                              render={(record) => record.orner_telephone ?? ""}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                          <div style={{ display: "flex", marginBottom: "5px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("FAX")}
                            <FunctionField
                              render={(record) => record.orner_fax ?? ""}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "flex", marginBottom: "5px", flex: 1, width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                            {labelStyle("住所")}
                            <FunctionField
                              render={record => {
                                return `${record.orner_postCode ? record.orner_postCode : ""} ${record.orner_address ?? ""}${record.orner_address2 ?? ""}${record.orner_address3 ?? ""}${record.orner_address4 ?? ""}${record.orner_address5 ?? ""}`;
                              }}
                              style={{ paddingLeft: "5px" }}
                            />
                          </div>
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", width: "100%", backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("備考")}
                          <TextField source="orner_remarks" label={labelStyle("備考")} style={{ paddingLeft: "5px" }} />
                        </div>
                      </div>

                    </div>
                  </>
                ) : (
                  <></>
                )}
                <div style={{ fontWeight: "bold" }}>履歴情報</div>
                <Box
                  sx={{
                    height: '300px',
                    overflowY: 'auto',
                    border: '1px solid #ccc',
                    padding: '5px',
                  }}
                >
                  {(customer.isCleanCus) ? (
                    <div style={{ width: "100%", margin: "0 5px" }}>
                      <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>最終清掃受付履歴</div>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("受付日")}
                          <DateField source="receptDate" label={labelStyle("受付日")} style={{ paddingLeft: "5px" }} />
                        </div>

                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("清掃予定日")}
                          <DateField source="exCleaningDate" label={labelStyle("清掃予定日")} style={{ paddingLeft: "5px" }} />
                        </div>

                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("清掃予定時間")}
                          <FunctionField
                            source="exCleaningTime" label={labelStyle("清掃予定時間")} style={{ paddingLeft: "5px" }}
                            render={(record) => {
                              return record.exCleaningTime ? cleanTimeChoices.find(choice => choice.id === record.exCleaningTime)?.name : ""
                            }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("地区")}
                          <TextField source="district" label={labelStyle("地区")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("汲取予定量\n(㎥)")}
                          <FunctionField
                            label={labelStyle("汲取予定量")}
                            render={record => {
                              return `${record.exPumpingAmount ?? ""}`;
                            }}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ backgroundColor: "#f2f2f2", display: "flex", verticalAlign: "middle" }}>
                          {historyButton(
                            `/cleanReceptHistory?customer=${customer.id}`,
                            `/cleanReceptHistory/create?customer=${customer.id}`,
                            `/cleanReceptHistory/${customer.receptId}`,
                            customer.receptId
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {(customer.isCleanCus) ? (
                    <div style={{ width: "100%", margin: "0 5px" }}>
                      <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>最終清掃履歴</div>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("清掃日")}
                          <DateField source="cleaningDate" label={labelStyle("清掃日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("担当者")}
                          <FunctionField
                            label={labelStyle("担当者")}
                            render={record => {
                              return `${record.ch_staffName ?? ""}${record.ch_staffName2 ? "・" + record.ch_staffName2 : ""}`;
                            }}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("汲取実量\n(㎥)")}
                          <FunctionField
                            label={labelStyle("汲取実量")}
                            render={record => {
                              return `${record.pumpingWeigh ?? ""}`;
                            }}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("汲取金額\n(税抜き)")}
                          <FunctionField
                            label={labelStyle("汲取金額")}
                            render={record => {
                              return (record.pumpingWeigh && record.pumpingPay_ch) ? `${(record.pumpingPay_ch * record.pumpingWeigh).toLocaleString()}円` : "";
                            }}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("請求日")}
                          <DateField source="ch_invoiceDate" label={labelStyle("請求日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("再発行日")}
                          <DateField source="ch_reissueDate" label={labelStyle("再発行日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("領収状況")}
                          <FunctionField
                            label={labelStyle("領収状況")}
                            render={record => {
                              return customer.ch_invoiceId ? record.ch_isPay ? <>領収済み</> : <span style={{ color: "red" }}>未領収</span> : <></>;
                            }}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("領収日")}
                          <DateField source="ch_receiptDate" label={labelStyle("領収日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ backgroundColor: "#f2f2f2", display: "flex", verticalAlign: "middle" }}>
                          {historyButton(
                            `/cleanHistory?customer=${customer.id}`,
                            `/cleanHistory/create?customer=${customer.id}`,
                            `/cleanHistory/${customer.cleaningId}`,
                            customer.cleaningId
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}


                  {(customer.isInspectCus) ? (
                    <div style={{ width: "100%", margin: "0 5px" }}>
                      <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>最終点検履歴</div>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("点検日")}
                          <DateField source="inspectDate" label={labelStyle("点検日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("担当者")}
                          <FunctionField
                            label={labelStyle("担当者")}
                            render={record => {
                              return `${record.sh_staffName ?? ""}`;
                            }}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("請求日")}
                          <DateField source="sh_invoiceDate" label={labelStyle("請求日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("再発行日")}
                          <DateField source="sh_reissueDate" label={labelStyle("再発行日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("領収状況")}
                          <FunctionField
                            label={labelStyle("領収状況")}
                            render={record => {
                              return customer.sh_invoiceId ? record.sh_isPay ? <>領収済み</> : <span style={{ color: "red" }}>未領収</span> : <></>;
                            }}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("領収日")}
                          <DateField source="sh_receiptDate" label={labelStyle("領収日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ backgroundColor: "#f2f2f2", display: "flex", verticalAlign: "middle" }}>
                          {historyButton(
                            `/inspectHistory?customer=${customer.id}`,
                            `/inspectHistory/create?customer=${customer.id}`,
                            `/inspectHistory/${customer.inspectId}`,
                            customer.inspectId
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}


                  {(customer.isConstructCus) ? (
                    <div style={{ width: "100%", margin: "0 5px" }}>
                      <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>最終修理履歴</div>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("修理日")}
                          <DateField source="constructDate" label={labelStyle("修理日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("担当者")}
                          <FunctionField
                            label={labelStyle("担当者")}
                            render={record => {
                              return `${record.rh_staffName ?? ""}`;
                            }}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("請求日")}
                          <DateField source="rh_invoiceDate" label={labelStyle("請求日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("再発行日")}
                          <DateField source="rh_reissueDate" label={labelStyle("再発行日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("領収状況")}
                          <FunctionField
                            label={labelStyle("領収状況")}
                            render={record => {
                              return customer.rh_invoiceId ? record.rh_isPay ? <>領収済み</> : <span style={{ color: "red" }}>未領収</span> : <></>;
                            }}
                            style={{ paddingLeft: "5px" }}
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                          {labelStyle("領収日")}
                          <DateField source="rh_receiptDate" label={labelStyle("領収日")} style={{ paddingLeft: "5px" }} />
                        </div>
                        <div style={{ backgroundColor: "#f2f2f2", display: "flex", verticalAlign: "middle" }}>
                          {historyButton(
                            `/constructHistory?customer=${customer.id}`,
                            `/constructHistory/create?customer=${customer.id}`,
                            `/constructHistory/${customer.constructId}`,
                            customer.constructId
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div style={{ width: "100%", margin: "0 5px", marginBottom: "10px" }}>
                    <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>最終請求履歴</div>
                    <div style={{ display: "flex" }}>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("請求対象区分")}
                        <FunctionField
                          label="請求対象区分"
                          render={record => {
                            const choice = invoiceChoices.find(choice => choice.id === record.invoiceCategory);
                            return choice ? choice.name : "";
                          }}
                        />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("清掃日")}
                        <DateField source="invoiceDate" label={labelStyle("請求日")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("再発行日")}
                        <DateField source="reissueDate" label={labelStyle("再発行日")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("領収状況")}
                        <FunctionField
                          label={labelStyle("領収状況")}
                          render={record => {
                            return customer.invoiceId ? record.isPay ? <>領収済み</> : <span style={{ color: "red" }}>未領収</span> : <></>;
                          }}
                          style={{ paddingLeft: "5px" }}
                        />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("領収日")}
                        <DateField source="receiptDate" label={labelStyle("領収日")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ backgroundColor: "#f2f2f2", display: "flex", verticalAlign: "middle" }}>
                        {historyButton(
                          `/invoiceHistory?customer=${customer.id}`,
                          `/invoiceHistory/create?customer=${customer.id}`,
                          `/invoiceHistory/${customer.invoiceId}`,
                          customer.invoiceId
                        )}
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "100%", margin: "0 5px", marginBottom: "10px" }}>
                    <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>最終問い合わせ履歴</div>
                    <div style={{ display: "flex" }}>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("問い合わせ日")}
                        <DateField source="contactDate" label={labelStyle("問い合わせ日")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 4, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("問い合わせ内容")}
                        <TextField source="th_content" label={labelStyle("問い合わせ内容")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ backgroundColor: "#f2f2f2", display: "flex", verticalAlign: "middle" }}>
                        {historyButton(
                          `/contactHistory?customer=${customer.id}`,
                          `/contactHistory/create?customer=${customer.id}`,
                          `/contactHistory/${customer.contactId}`,
                          customer.contactId
                        )}
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "100%", margin: "0 5px", marginBottom: "10px" }}>
                    <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>最終訪問履歴</div>
                    <div style={{ display: "flex" }}>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("訪問日")}
                        <DateField source="visitDate" label={labelStyle("訪問日")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("担当者")}
                        <FunctionField
                          label={labelStyle("担当者")}
                          render={record => {
                            return `${record.vh_staffName ?? ""}`;
                          }}
                          style={{ paddingLeft: "5px" }}
                        />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 4, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("訪問内容")}
                        <TextField source="vh_content" label={labelStyle("訪問内容")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ backgroundColor: "#f2f2f2", display: "flex", verticalAlign: "middle" }}>
                        {historyButton(
                          `/visitHistory?customer=${customer.id}`,
                          `/visitHistory/create?customer=${customer.id}`,
                          `/visitHistory/${customer.visitId}`,
                          customer.visitId
                        )}
                      </div>
                    </div>
                  </div>

                  <div style={{ width: "100%", margin: "0 5px", marginBottom: "10px" }}>
                    <div style={{ backgroundColor: "#1976d2", padding: "3px", margin: "10px 0 5px", fontSize: "12px", color: "#fff", whiteSpace: "nowrap" }}>最終見積履歴</div>
                    <div style={{ display: "flex" }}>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("見積作成日")}
                        <DateField source="createEstimateDate" label={labelStyle("見積作成日")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("見積依頼日")}
                        <DateField source="requestEstimateDate" label={labelStyle("見積依頼日")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("見積作成者")}
                        <TextField source="createrName" label={labelStyle("見積作成者")} style={{ paddingLeft: "5px" }} />
                      </div>
                      <div style={{ display: "flex", marginBottom: "5px", marginRight: "10px", flex: 1, backgroundColor: "#eee", border: "1px solid #777" }}>
                        {labelStyle("見積金額(税抜き)")}
                        <FunctionField source="estimateAmount" label={labelStyle("見積金額(税抜き)")} style={{ paddingLeft: "5px" }}
                          render={(record) => {
                            return record.estimateAmount ? `${record.estimateAmount.toLocaleString()}円` : ""
                          }}
                        />
                      </div>
                      <div style={{ backgroundColor: "#f2f2f2", display: "flex", verticalAlign: "middle" }}>
                        {historyButton(
                          `/estimateHistory?customer=${customer.id}`,
                          `/estimateHistory/create?customer=${customer.id}`,
                          `/estimateHistory/${customer.estimateId}`,
                          customer.estimateId
                        )}
                      </div>
                    </div>
                  </div>
                </Box>
              </SimpleShowLayout>
            </CardContent>
          </Card>
        </>
      )}
    </>
  );

};

export default CustomerShow;
